module.exports = __webpack_public_path__ + "media/main.3ac66923.mp4";